var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"wrapper2"}},[_c('div',{style:({'width':_vm.widthScroll}),attrs:{"id":"div2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }